import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Calendar: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30897)'>
        <path
          d='M20.3742 2.46714H17.4599V1.54735C17.4599 1.24508 17.2187 1 16.9213 1C16.6238 1 16.3826 1.24508 16.3826 1.54735V2.46714H12.7643V1.54735C12.7643 1.24508 12.5232 1 12.2257 1C11.9283 1 11.6871 1.24508 11.6871 1.54735V2.46714H8.06876V1.54735C8.06876 1.24508 7.82759 1 7.53014 1C7.23269 1 6.99152 1.24508 6.99152 1.54735V2.46714H4.07724C3.48313 2.46714 3 2.95823 3 3.56185V21.9053C3 22.5089 3.48313 23 4.07724 23H20.3742C20.9683 23 21.4514 22.5089 21.4514 21.9053V3.56185C21.4514 2.95823 20.9683 2.46714 20.3742 2.46714ZM6.99152 3.56185V4.48163C6.99152 4.78391 7.23269 5.02899 7.53014 5.02899C7.82759 5.02899 8.06876 4.78391 8.06876 4.48163V3.56185H11.6871V4.48163C11.6871 4.78391 11.9283 5.02899 12.2257 5.02899C12.5232 5.02899 12.7643 4.78391 12.7643 4.48163V3.56185H16.3826V4.48163C16.3826 4.78391 16.6238 5.02899 16.9213 5.02899C17.2187 5.02899 17.4599 4.78391 17.4599 4.48163V3.56185H20.3742V7.00032H4.07724V3.56185H6.99152ZM4.07724 21.9053V8.09502H20.3742V21.9053H4.07724Z'
          fill='url(#paint0_linear_12280_30897)'
          stroke='url(#paint1_linear_12280_30897)'
        />
        <path
          d='M18.2865 10.7266H6.16753C5.87008 10.7266 5.62891 10.9716 5.62891 11.2739C5.62891 11.5762 5.87008 11.8213 6.16753 11.8213H18.2865C18.5839 11.8213 18.8251 11.5762 18.8251 11.2739C18.8251 10.9716 18.5839 10.7266 18.2865 10.7266Z'
          fill='url(#paint2_linear_12280_30897)'
          stroke='url(#paint3_linear_12280_30897)'
        />
        <path
          d='M18.2865 14.457H6.16753C5.87008 14.457 5.62891 14.7021 5.62891 15.0044C5.62891 15.3067 5.87008 15.5517 6.16753 15.5517H18.2865C18.5839 15.5517 18.8251 15.3067 18.8251 15.0044C18.8251 14.7021 18.5839 14.457 18.2865 14.457Z'
          fill='url(#paint4_linear_12280_30897)'
          stroke='url(#paint5_linear_12280_30897)'
        />
        <path
          d='M18.2865 18.1797H6.16753C5.87008 18.1797 5.62891 18.4248 5.62891 18.727C5.62891 19.0293 5.87008 19.2744 6.16753 19.2744H18.2865C18.5839 19.2744 18.8251 19.0293 18.8251 18.727C18.8251 18.4248 18.5839 18.1797 18.2865 18.1797Z'
          fill='url(#paint6_linear_12280_30897)'
          stroke='url(#paint7_linear_12280_30897)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30897'
          x1='6.82086'
          y1='2.50015'
          x2='17.8479'
          y2='21.0365'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30897'
          x1='6.82086'
          y1='2.50015'
          x2='17.8479'
          y2='21.0365'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_30897'
          x1='8.36153'
          y1='10.8012'
          x2='8.41313'
          y2='12.0478'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_30897'
          x1='8.36153'
          y1='10.8012'
          x2='8.41313'
          y2='12.0478'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_30897'
          x1='8.36153'
          y1='14.5317'
          x2='8.41313'
          y2='15.7783'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_30897'
          x1='8.36153'
          y1='14.5317'
          x2='8.41313'
          y2='15.7783'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_30897'
          x1='8.36153'
          y1='18.2543'
          x2='8.41313'
          y2='19.501'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_30897'
          x1='8.36153'
          y1='18.2543'
          x2='8.41313'
          y2='19.501'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30897'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Calendar;
